import dialCode from '../../data/dialCode.json';
export const DialCodeList = (paramsObj) => {
  return dialCode;
};
